import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  GblReportheaderModality,
  GblReportHeaderModel,
  GblReportModel,
  GblReportViewModel,
  GeneralResModel,
} from "src/app/_models";
import { CommonResponse } from "src/app/_models/common-response.modle";
import { AutoCompleteResponse } from "src/app/_models/report/autocompleteresponse";
import { JasperReportDetails } from "src/app/_models/report/jasperreportdetails";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ReportService {
  private baseURL = `${environment.apiUrl}report/`;

  constructor(private _httpClient: HttpClient) {}

  getRptJobTypeSettingById(rptjobtypesettingId: number) {
    return this._httpClient.get<CommonResponse>(
      `${this.baseURL}GetReportJobtypeSettingById/${rptjobtypesettingId}`
    );
  }
  getRptJobTypeSettingList() {
    return this._httpClient.get<CommonResponse>(
      `${this.baseURL}GetReportJobtypeSetting`
    );
  }
  
  getActiveRptJobTypeSettingList() {
    return this._httpClient.get<CommonResponse>(
      `${this.baseURL}GetActiveReportJobtypeSetting`
    );
  }

  addRptJobTypeSetting(body:GblReportViewModel) {
    return this._httpClient.post<CommonResponse>(
      `${this.baseURL}AddReportJobtypeSetting`,body
    );
  }
  updateRptJobTypeSetting(body:GblReportViewModel) {
    return this._httpClient.post<CommonResponse>(
      `${this.baseURL}UpdateReportJobtypeSetting`,body
    );
  }
 deleteRptJobTypeSetting(body:GblReportViewModel) {
    return this._httpClient.post<CommonResponse>(
      `${this.baseURL}DeleteReportJobtypeSetting`,body
    );
  }

  getActiveReportList() {
    return this._httpClient.get<CommonResponse>(
      `${this.baseURL}GetActiveReport`
    );
  }
  getAllReportList() {
    return this._httpClient.get<GeneralResModel<GblReportModel[]>>(
      `${this.baseURL}GetReport`
    );
  }

  getReportByUserId(userId: number) {
    return this._httpClient.get<GeneralResModel<GblReportViewModel[]>>(
      `${this.baseURL}GetReportByUserId/${userId}`
    );
  }

  getReportParamSettingByReportUserId(reportId: number, userId: number) {
    return this._httpClient.get<GeneralResModel<GblReportViewModel[]>>(
      `${this.baseURL}GetReportParamSettingByReportUserId/${reportId}/${userId}`
    );
  }
  getAccssionNowithOrgName(filter: string,type:string,status:string) {
    return this._httpClient.get<GeneralResModel<AutoCompleteResponse[]>>(
      `${this.baseURL}GetAccessionNoWithOrgName/${filter}/${type}/${status}`
    );
  }
  GetReportheaderByOrg(orgId: number) {
    return this._httpClient.get<GeneralResModel<GblReportHeaderModel[]>>(
      `${this.baseURL}GetReportheaderByOrg/${orgId}`
    );
  }
  // getReportShow(url: string) {
  //   return this._httpClient.get<GeneralResModel<JasperReportDetails>>(
  //     `${this.baseURL}GetAccessionNoWithOrgName/${url}`
  //   );
  // }
  // GetReportheaderById(userId: number) {
  //   return this._httpClient.get<GeneralResModel<GblReportHeaderModel[]>>(
  //     `${this.baseURL}GetReportheaderById/${userId}`
  //   );
  // }
    AddReportHeaderSetting(body:GblReportHeaderModel) {
    return this._httpClient.post<CommonResponse>(
      `${this.baseURL}AddReportHeaderSetting`,body
    );
  }
    GetReportheaderById(Id: number) {
    return this._httpClient.get<GeneralResModel<GblReportHeaderModel>>(
      `${this.baseURL}GetReportheaderById/${Id}`
    );
  }
    AddReportheader(body:GblReportHeaderModel) {
    return this._httpClient.post<CommonResponse>(
      `${this.baseURL}AddReportheader`,body
    );
  }
  UpdateReportheader(body:GblReportHeaderModel) {
    return this._httpClient.post<CommonResponse>(
      `${this.baseURL}UpdateReportheader`,body
    );
  }
  ReportLogoUpload(body: FormData) {
    return this._httpClient.post<CommonResponse>(`${this.baseURL}ReportLogoUpload`, body);
  }
  ReportHeaderUpload(body: FormData) {
    return this._httpClient.post<CommonResponse>(
      `${this.baseURL}ReportHeaderUpload`,
      body,
    );
  }

    GetReportheaderModalityByOrg(orgId: number) {
    return this._httpClient.get<GeneralResModel<GblReportheaderModality[]>>(
      `${this.baseURL}GetReportheaderModalityByOrg/${orgId}`
    );
  }
    GetReportheaderModalityById(Id: number) {
    return this._httpClient.get<GeneralResModel<GblReportheaderModality>>(
      `${this.baseURL}GetReportheaderModalityById/${Id}`
    );
  }
    AddReportheaderModality(body:GblReportheaderModality) {
    return this._httpClient.post<CommonResponse>(
      `${this.baseURL}AddReportheaderModality`,body
    );
  }
  UpdateReportheaderModality(body:GblReportheaderModality) {
    return this._httpClient.post<CommonResponse>(
      `${this.baseURL}UpdateReportheaderModality`,body
    );
  }
}
